<template>
<!-- 自营商品分类 -->
<div class="" style="height:100%">
    <div class="selectionBar">
        <div class="flex flex-ai-c flex-wrap">
            <label>场景：</label>
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" style="margin-left:auto" @click="edit()">添加</el-button>
        </div>
    </div>
    <!-- 表格 -->
    <div class="table" style="height:calc( 100% - 140px )">
        <el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 5px )">
            <!-- <el-table-column prop="icon" label="图标" width="130">
                <template slot-scope="scope">
                    <el-image :src="getImgUrl(scope.row.icon)" fit="cover" class="main_pic" :preview-src-list="[domain + '/' + scope.row.icon]">
                    </el-image>
                </template>
            </el-table-column> -->
            <el-table-column prop="name" label="分类名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" width="120" align="center">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" icon="el-icon-edit" size="small" @click="edit(scope.row)"></el-button>
                        <el-button type="primary" icon="el-icon-delete" size="small" @click="del(scope.row)"></el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <!-- 新建框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false" width="500px">
        <el-form ref="formAuth" :rules="formRules" :model="formData" label-position="top" size="small" class="alertForm">
            <el-form-item class="hide"></el-form-item>
            <el-form-item label="分类名称" prop="name" style="width:100%">
                <el-input v-model="formData.name" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item class="hide"></el-form-item>
            <el-form-item label="上传图标" prop="icon" style="width:100%">
                <div class="photoBox">
                    <div class="photo flex flex-wrap">
                        <div class="" v-if="formData.icon!=''">
                            <el-image :src="getImgUrl(formData.icon)" fit="cover" :preview-src-list="[domain + '/' + formData.icon]"></el-image>
                            <i class="el-icon-error" @click="deleteMain_pic(index)"></i>
                        </div>
                        <label v-else>
                            <i class="el-icon-plus"></i>
                            <input type="file" class="uploadMainPic" :value="filevalue" style="display:none" @change="upload('uploadMainPic')" />
                        </label>
                    </div>
                </div>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submit()">确 定</el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            title: '添加分类',
            dialogFormVisible: false,
            formLabelWidth: '80px',
            filevalue: '',
            formData: {
                icon: ''
            },
            formRules: {
                name: [{
                    required: true,
                    message: '请输入分类名称',
                    trigger: 'blur'
                }],
                // icon: [{
                //     required: true,
                //     message: '请上传图标',
                //     trigger: 'blur'
                // }],
            },
            dialogVisible: false,
            dialogImageUrl: '',
            list: [],
            icon: [{
                required: true,
                message: '请上传图标',
                trigger: 'blur'
            }],

            curr: 1, //页码
            row: 20, //每页条数
            pages: 1, //总页数
            count: 0, //总条数
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 查看图片
        showImg: function(url) {
            this.dialogImageUrl = this.domain + '/' + url;
            this.dialogVisible = true;
        },
        // 图片转换
        getImgUrl(item) {
            var url = this.domain + '/' + item;
            return url;
        },
        // 附件和图片上传获取接口返回的路径
        upload(uploadelement) {
            var loads = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                customClass: 'myLoading',
            });
            var formData = new FormData();
            // console.log(document.querySelector('.' + uploadelement).files[0]);
            formData.append('pic', document.querySelector('.' + uploadelement).files[0]);
            axios.post(this.domain + '/admin/goods/upPic', formData).then(re => {
                loads.close();
                if(re.data.code == '0000') {
                    this.filevalue = "";
                    this.formData.icon = re.data.data.saveName;
                } else {
                    this.$message.error(re.data.msg);
                }
                this.$refs.formAuth.validateField('icon');
            }).catch(function() { // 请求失败处理
                loads.close();
            });
        },
        // 删除主图
        deleteMain_pic() {
            this.formData.icon = '';
            this.$refs.formAuth.validateField('icon');
        },
        getList() {
            this.http.post('/admin/goodsZiType/index', {
                // curr: this.curr,
                // row: 9999,
                search: this.searchValue
            }).then(res => {
                this.list = res.list;
                this.curr = res.curr;
                this.pages = res.pages;
                this.count = res.count;
            });
        },
        edit(row) {
            if(row) {
                this.ispwd = false;
                this.formData = JSON.parse(JSON.stringify(row));
                this.title = '编辑分类';
            } else {
                this.ispwd = true;
                this.formData = {
                    icon: ''
                };
                this.title = '添加分类';
            }
            this.dialogFormVisible = true;
        },
        del(row) {
            this.$confirm(`确定删除吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                var url = '/admin/goodsZiType/delete';
                this.http.post(url, {
                    id: row.id,
                }).then(() => {
                    this.getList();
                    this.$message({
                        type: 'success',
                        message: '已删除!'
                    });
                })
            }).catch()
        },
        submit() {
            // 验证
            this.$refs['formAuth'].validate((valid) => {
                if(valid) {
                    var apiUrl = "/admin/goodsZiType/save";
                    this.http.post(apiUrl, this.formData).then(() => {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.getList();
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //翻页
        currentChange: function(curr) {
            this.curr = curr;
            this.getList();
        },
        //改变每页条数
        sizeChange: function(row) {
            this.row = row;
            this.getList();
        },
    }
}
</script>

<style lang="css" scoped>
</style>
